import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { PUR2010_R01DetailDto } from "../Dto_PUR2010_R01";

interface UsePUR2010_R01CellChangeProps {
	PUR2010_R01DetailList: PUR2010_R01DetailDto[];
	originalPUR2010_R01DetailList: PUR2010_R01DetailDto[];
	updatePUR2010_R01DetailList: (index: number, data: PUR2010_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<PUR2010_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
}

export function usePUR2010_R01CellChange({
	PUR2010_R01DetailList,
	originalPUR2010_R01DetailList,
	updatePUR2010_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
}: UsePUR2010_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const PUR2010R01Config = createModuleConfig.PUR2010();

	const fieldConfigWithSearch = {
		...PUR2010R01Config.fieldConfig,
		codeSearchFields: {
			...PUR2010R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...PUR2010R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFunction: searchExactItemCode,
			},
		},
	};

	const PUR2010_FIELD_MAPPING = {
		qtyField: "billQty",
		priceField: "billPrice",
		dcField: "dcAmt",
		amountField: "billAmt",
		preventNegative: true,
	};

	return useCommonDetailTableHandlers<PUR2010_R01DetailDto>({
		detailList: PUR2010_R01DetailList,
		updateDetailList: updatePUR2010_R01DetailList,
		originalDetailList: originalPUR2010_R01DetailList,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: PUR2010R01Config.codeSearchConfig,
		calculateAmount: (data: PUR2010_R01DetailDto) =>
			calculateDetailAmount(data, PUR2010_FIELD_MAPPING),
		setCodeSearchModalProps,
		gridRef,
	});
}
